export default "/react/logoTelemetr-5c43eb97.png";